import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { SdFormErrorComponent } from '../form-error/form-error.component';

import { ErrorTranslateService } from '../error-translate-service';
import { BaseFormErrorTranslateService } from './base-form-error-translate.service';

@Component({
  selector: 'sd-form-common-error',
  templateUrl: './form-common-error.component.html',
  standalone: true,
  imports: [SdFormErrorComponent],
  providers: [
    { provide: BaseFormErrorTranslateService, useClass: ErrorTranslateService }
  ]
})
/**
 * Displays standard errors for the target component.
 * To be used in the following way:
 * <sd-form-common-error control="myControl"></sd-form-common-error>
 */
export class SdFormCommonErrorComponent implements OnInit {
  readonly commonErrorsKey = ['required', 'maxlength', 'minlength'];

  @Input()
  control: AbstractControl;

  constructor(
    private readonly errorTranslateService: BaseFormErrorTranslateService,
  ) {
    if (
      errorTranslateService.constructor.name === 'BaseFormErrorTranslateService'
    ) {
      throw new Error(
        'Aucun service de translation d\'erreur disponible dans le scope',
      );
    }
  }

  ngOnInit(): void {
    if (!this.control) {
      throw new Error(
        '[SdFormCommonErrorComponent] L\'attribut control est obligatoire',
      );
    }
  }

  getLabel(errorKey: string) {
    if (this.control.hasError(errorKey)) {
      const errorsDetail = this.control.errors[errorKey];
      return this.errorTranslateService.translate(errorKey, errorsDetail);
    }
    return '';
  }
}
